export { default as templatesMock } from './templates.mock.json';
export { default as templatesEsMock } from './templatesEs.mock.json';
export { default as myCreationsMock } from './myCreations.json';
export { default as recommEsMock } from './recommEs.json';
export { default as recommMock } from './recomm.json';

export { default as postInstagram } from './notification.json';
